import styled, { css } from 'styled-components';
import __ from '../../utils/translator';
import confidentialLabelStyle from '../../utils/confidentialLabelStyle';
import themeResponsiveProperty from '../responsive/themeResponsiveProperty';

export default styled.div`
  // VTA-346: in the iPad application, when the text is too long it overflows
  // outside of the container and makes the content scrollable in all four
  // directions. We prevent this from happening with "overflow: hidden". The
  // downside of that is that text longer than three rows will be cut (already
  // three rows is a stretch and has wrong spacing).
  overflow: hidden;

  // We need to set position: relative in case there are absolute positioned
  // labels inside.
  position: relative;

  height: 100%;
  padding: ${themeResponsiveProperty('1rem 20% 1rem 1rem', '1rem 40% 1rem 1rem')};
  box-shadow: 0 .125rem 1rem rgba(0,0,0,.1);
  background: linear-gradient(90deg, rgba(0,0,0,.6) 10%, rgba(0,0,0,0) 80%),
              #000 url("${props => props.cover}") no-repeat center;
  background-size: cover;
  color: #fefefe;

  ${({ related }) => related ? css`
    width: 12.75rem;
    filter: grayscale(1);
    padding: .5rem 40% .5rem .5rem;
    box-shadow: .125rem .125rem .8125rem .0625rem rgba(0,0,0,.2);
  ` : css`
    width: ${themeResponsiveProperty('13.5rem', '23.75rem')};
  `};

  ${props => props.fullWidth && css`
    width: 100%;
  `};

  ${props => props.theme.isMobile && css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `};
`;
